import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";

const LanguageSelector = ({ langueActive, onChangeLangue, vueActuelle }) => {
  const [mounted, setMounted] = useState(false);

  const langs = [
    { key: "fr", label: "FR" },
    { key: "de", label: "DE" },
    { key: "en", label: "EN" },
  ];

  useEffect(() => {
    setMounted(true);
  }, []);

  if (vueActuelle !== "accueil") return null;
  if (!mounted || typeof document === "undefined" || !document.body)
    return null;

  return createPortal(
    <div
      style={{
        position: "fixed",
        top: "72px",
        left: "14px", // ← déplacé à gauche
        zIndex: 99999,
        display: "flex",
        flexDirection: "row", // ← horizontal
        gap: "8px",
        alignItems: "center",
      }}
    >
      {langs.map((l) => {
        const active = langueActive === l.key;

        return (
          <button
            key={l.key}
            type="button"
            onClick={() => onChangeLangue(l.key)}
            aria-pressed={active}
            style={{
              width: "42px",
              height: "28px",
              padding: "0",
              background: "rgba(255,255,255,0.08)",
              color: active ? "#8b4513" : "rgba(0,0,0,0.58)",
              border: active
                ? "1px solid rgba(212,175,55,0.95)"
                : "1px solid rgba(0,0,0,0.10)",
              borderRadius: "10px",
              cursor: "pointer",
              fontSize: "9px",
              fontWeight: 600,
              letterSpacing: "0.12em",
              textTransform: "uppercase",
              transition: "all 0.2s ease",
              boxShadow: active
                ? "0 4px 10px rgba(212,175,55,0.14)"
                : "0 2px 8px rgba(0,0,0,0.04)",
              backdropFilter: "blur(4px)",
            }}
          >
            {l.label}
          </button>
        );
      })}
    </div>,
    document.body
  );
};

export default LanguageSelector;
